import { useContent } from "contexts/contentContext/contentContext";
import SubUserTable from "../ProfileUser/Profile/SubUsers/SubUserTable";
import { useProfile } from "contexts/profileContext/profileContext";
import QueryParamDropdownFilter from "components/Reusable/QueryParamDropdownFilter/QueryParamDropdownFilter";
import { memo, useEffect, useMemo, useState } from "react";
import { QueryParamDropdownListT } from "components/Reusable/QueryParamDropdownFilter/helpers/useQueryParamDropdown";
import QueryParamsBar from "components/Reusable/QueryParamsBar/QueryParamsBar";
import InviteSubUserButton from "../ProfileUser/Profile/SubUsers/InviteSubUserButton";
import SearchBar from "./components/SearchBar/SearchBar";
import getSelectedCount from "./helpers/getSelectedCount";
import addPostfixForObjectKeys from "./helpers/addPostfixForObjectKeys";

import "./styles.scss";
import { useUser } from "contexts/userContext/userContext";
import { useNavigate } from "react-router-dom";

const INITIAL_PAGE_INDEX = 1;
const DROPDOWN_DATA: QueryParamDropdownListT = {
  "user-status": [
    "active",
    "suspended",
    "pending",
    "expired",
    { name: "removed", type: "radio" },
  ],
  "permission-level": ["owner", "admin", "user", "supervisor"],
};

const AccountUsers = memo(() => {
  const { getTextByKey, getLanguage } = useContent();
  const navigate = useNavigate();
  const {
    getSubUserData,
    loading,
    setPermissionFilter,
    setStatusFilter,
    getStatusFilter,
    getPermissionFilter,
    getSubUsersCounts,
    setCurrentPage,
  } = useProfile();
  const { getUserData } = useUser();

  const [selectedCount, setSelectedCount] = useState(0);

  useEffect(() => {
    if (
      getUserData() &&
      !getUserData().isTopUser &&
      getUserData().subUserRole !== "Admin"
    ) {
      window.open(
        window.location.origin + `/${getLanguage()}/user/profile/account`,
        "_self"
      );
    }
  }, [getUserData, getLanguage, navigate]);

  const barParams = useMemo(
    () => ({
      "user-status": getStatusFilter(),
      "permission-level": getPermissionFilter(),
    }),
    [getStatusFilter(), getPermissionFilter()]
  );

  // -------------------------------- synchronize store with the query params --------------------------------

  const onSelect = (selected: QueryParamDropdownListT) => {
    const count = getSelectedCount(selected);

    setCurrentPage(INITIAL_PAGE_INDEX);
    setSelectedCount(count);
    setStatusFilter(selected?.["user-status"]);
    setPermissionFilter(selected?.["permission-level"]);
  };

  // ---------------------------------------------------------------------------------------------------------

  const counters = useMemo(
    () => ({
      for: "user-status",
      counters: addPostfixForObjectKeys(
        getSubUsersCounts() as { [key: string]: number },
        "user-status"
      ),
    }),
    [getSubUsersCounts()]
  );

  return (
    <div className="account-users-wrapper">
      <div className="header">
        <h2>
          {getTextByKey("account-users")}{" "}
          {!loading && `(${getSubUserData().numberOfUsers || 0})`}
        </h2>
        {!getStatusFilter()?.includes("removed") ? (
          <span className="sub-users-active">{`${getTextByKey(
            "sub-users-active"
          )}: ${getSubUsersCounts()?.active || 0}`}</span>
        ) : (
          <span />
        )}
        <QueryParamsBar params={barParams} onChange={onSelect} />
        <QueryParamDropdownFilter
          queryParams={DROPDOWN_DATA}
          onChange={onSelect}
          selectedCount={selectedCount}
          counters={counters}
        />
        <SearchBar />
        <InviteSubUserButton />
      </div>
      <SubUserTable withoutAddSubUserButton pageSize={25} />
    </div>
  );
});

export default AccountUsers;
